/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:18 GMT
 */
/* mixins & extensions */
/* helper to properly scale internal durations */
/**
* Currently only used in Checkbox.
*/
:host([disabled]) {
  cursor: default;
  -webkit-user-select: none;
          user-select: none;
  opacity: var(--calcite-opacity-disabled);
}

:host([disabled]) *,
:host([disabled]) ::slotted(*) {
  pointer-events: none;
}

:host {
  display: inline;
}

:host a,
:host span {
  position: relative;
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  border-radius: 0px;
  border-style: none;
  font-family: inherit;
  transition: background-color, block-size, border-color, box-shadow, color, inset-block-end, inset-block-start, inset-inline-end, inset-inline-start inset-size, opacity, outline-color, transform var(--calcite-animation-timing) ease-in-out 0s, outline 0s, outline-offset 0s;
  text-decoration: none;
  line-height: inherit;
  font-size: inherit;
  -webkit-appearance: none;
}
:host a:hover,
:host span:hover {
  text-decoration: none;
}

:host a,
:host span {
  outline-color: transparent;
}
:host a:focus,
:host span:focus {
  outline: 2px solid var(--calcite-ui-focus-color, var(--calcite-color-brand));
  outline-offset: calc(
            2px *
            calc(
              1 -
              2 * clamp(
                0,
                var(--calcite-offset-invert-focus),
                1
              )
            )
          );
}

calcite-icon {
  inline-size: 1em;
  block-size: 1em;
  min-inline-size: unset;
  min-block-size: unset;
}

.calcite-link--icon {
  vertical-align: middle;
  transition: background-color, block-size, border-color, box-shadow, color, inset-block-end, inset-block-start, inset-inline-end, inset-inline-start inset-size, opacity, outline-color, transform var(--calcite-animation-timing) ease-in-out 0s, outline 0s, outline-offset 0s;
  margin-block-start: -0.25em;
}

:host .calcite-link--icon.icon-start {
  margin-inline-end: 0.5rem;
}

:host .calcite-link--icon.icon-end {
  margin-inline-start: 0.5rem;
}

:host span,
:host a {
  position: relative;
  display: inline;
  border-style: none;
  background-color: transparent;
  padding: 0px;
  color: var(--calcite-color-text-link);
  transition: background-color, block-size, border-color, box-shadow, color, inset-block-end, inset-block-start, inset-inline-end, inset-inline-start inset-size, opacity, outline-color, transform var(--calcite-animation-timing) ease-in-out 0s, outline 0s, outline-offset 0s;
  line-height: inherit;
  white-space: initial;
  background-image: linear-gradient(currentColor, currentColor), linear-gradient(var(--calcite-color-brand-underline), var(--calcite-color-brand-underline));
  background-position-x: 0%, 100%;
  background-position-y: min(1.5em, 100%);
  background-repeat: no-repeat, no-repeat;
  background-size: 0% 1px, 100% 1px;
}
:host span:hover, :host span:focus,
:host a:hover,
:host a:focus {
  background-size: 100% 1px, 100% 1px;
}
:host span:active,
:host a:active {
  background-size: 100% 2px, 100% 2px;
}
:host span.calcite--rtl,
:host a.calcite--rtl {
  background-position: 100% 100%, 100% 100%;
}

:host([disabled]) ::slotted([calcite-hydrated][disabled]),
:host([disabled]) [calcite-hydrated][disabled] {
  /* prevent opacity stacking */
  opacity: 1;
}

.interaction-container {
  display: contents;
}

:host([hidden]) {
  display: none;
}

[hidden] {
  display: none;
}